// extracted by mini-css-extract-plugin
export default {"request_page_container":"Request_request_page_container__3HN0L","page_heading":"Request_page_heading__NqBPJ","request_table_fc":"Request_request_table_fc__wlUDc"};